exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  margin: 0;\n  font-family: monospace;\n  background: #4c5b5d;\n  font-size: 12;\n  color: white;\n  -webkit-font-smoothing: antialiased;\n  font-weight: 100;\n  height: 100vh;\n  overflow: hidden;\n}\n.grid-item {\n  background: white;\n  color: black;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.main {\n  height: 100%;\n  width: 100%;\n}\n.opts {\n  flex-wrap: wrap;\n}\n.toggle {\n  border-radius: 2px;\n  background: #404E4F;\n  color: #BFBFBF;\n  cursor: pointer;\n  font-weight: 600;\n  padding: 2px 4px;\n  margin: 2px;\n}\n.toggle.on {\n  color: lime;\n}\n", ""]);

// exports
